// v1.5.4 FIXED (No syntax errors + admin-safe structure)

import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const ShippingAddress = () => {
  const { shippingAddress, updateShippingAddress } = useAuth();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    address: '',
    city: '',
    postcode: '',
    country: ''
  });

  const [message, setMessage] = useState('');

  /* ---------------- LOAD EXISTING ADDRESS ---------------- */
  useEffect(() => {
    if (shippingAddress) {
      setFormData(shippingAddress);
    }
  }, [shippingAddress]);

  /* ---------------- HANDLE INPUT ---------------- */
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  /* ---------------- SUBMIT FORM ---------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await updateShippingAddress(formData);

    setMessage(result.message);

    if (result.success) {
      setTimeout(() => {
        navigate('/order-summary');
      }, 1200);
    } else {
      setTimeout(() => setMessage(''), 3000);
    }
  };

  /* ---------------- UI ---------------- */
  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light py-5">
      <div
        className="card shadow-lg p-4"
        style={{
          maxWidth: '500px',
          width: '100%',
          borderRadius: '12px'
        }}
      >
        <h3 className="text-center mb-4 text-primary">
          Shipping Address
        </h3>

        {/* SUCCESS MESSAGE */}
        {message && (
          <div className="alert alert-success text-center">
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="p-2">

          {/* ADDRESS */}
          <div className="mb-3">
            <label className="form-label">Street Address</label>
            <input
              type="text"
              name="address"
              className="form-control form-control-lg"
              value={formData.address}
              onChange={handleChange}
              required
            />
          </div>

          {/* CITY */}
          <div className="mb-3">
            <label className="form-label">City</label>
            <input
              type="text"
              name="city"
              className="form-control form-control-lg"
              value={formData.city}
              onChange={handleChange}
              required
            />
          </div>

          {/* POSTCODE */}
          <div className="mb-3">
            <label className="form-label">Postcode</label>
            <input
              type="text"
              name="postcode"
              className="form-control form-control-lg"
              value={formData.postcode}
              onChange={handleChange}
              required
            />
          </div>

          {/* COUNTRY */}
          <div className="mb-4">
            <label className="form-label">Country</label>
            <input
              type="text"
              name="country"
              className="form-control form-control-lg"
              value={formData.country}
              onChange={handleChange}
              required
            />
          </div>

          {/* BUTTON */}
          <button
            type="submit"
            className="btn btn-primary w-100 py-2"
            style={{ borderRadius: '8px' }}
          >
            Save Address
          </button>

        </form>
      </div>
    </div>
  );
};

export default ShippingAddress;